<template>
  <v-content>
    <!-- Floating action button -->
    <action-button/>

    <!-- Mapbox container -->
    <div id="map"/>

    <!-- Mapbox component -->
    <mapbox
      access-token=''
      :map-options="{
        style: {
          glyphs: 'https://dvn3ptw8fp74t.cloudfront.net/{fontstack}/{range}.pbf',
          version: 8,
          sources: {
            'osm-tiles': {
              type: 'raster',
              tiles: [
              'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png',
              'https://b.tile.openstreetmap.org/{z}/{x}/{y}.png'
              ],
              tileSize: 256
            },
            'marker-layer-source': {
              type: 'geojson',
              data: {
                  'type': 'FeatureCollection',
                  'features': [{
                      'type': 'Feature',
                      'properties': {},
                      'geometry': {
                          'type': 'Point',
                          'coordinates': [
                              -76.53063297271729,
                              39.18174077994108
                          ]
                      }
                  }]
              }
            }
          },
          layers: [{
            id: 'osm-tiles',
            type: 'raster',
            source: 'osm-tiles',
            minzoom: 0,
            maxzoom: 22
          },{
            id: 'marker-layer-bottom',
            type: 'circle',
            source: 'marker-layer-source'
          },{
            id: 'marker-layer-polygons',
            type: 'circle',
            source: 'marker-layer-source'
          },{
            id: 'marker-layer-labels',
            type: 'circle',
            source: 'marker-layer-source'
          }]
        },
        center: [-122.937613, 50.099706],
        zoom: 12,
        bearing: 150
      }"
      :geolocate-control="{
        show: true, 
        position: 'top-right'
      }"
      @map-load="mapLoaded"
      @map-init="mapInitialized">
    </mapbox>
  </v-content>
</template>

<!-- "Scoped" CSS limited to this component only -->
<style scoped>
  #map {
    width: fill;
    height: 100%;
    max-height: 100vh;
    background-color: rgb(207, 57, 57)!important;
  }
</style>
<script>
  import Vue from 'vue'
  import Vuex from 'vuex'
  import actionButton from './actionButton.vue'
  import mixinSatSummer2014 from '../mixins/imagry/satSummer2014'
  import mixinLayerSnowmakingHydrants from '../mixins/layers/snowmakingHydrants'
  import mixinLayerLiftmaintenanceCables from '../mixins/layers/liftmaintenanceCables'

  Vue.use(Vuex)

  export default {
    mixins: [ mixinSatSummer2014, mixinLayerSnowmakingHydrants, mixinLayerLiftmaintenanceCables ],
    components: {
      'action-button': actionButton
    },
    methods: {
      mapInitialized (map) {
        this.map = map
      },
      mapLoaded (map) {
        // If default is set to true, make visible
        if (this.$store.state.toggle.imagry.summer_2014_40cm) {
          this.mapLayerSatSummer2014Add()
        }
        if (this.computedSnowmakingHydrantsMapVisibility) {
          this.mapLayerSnowmakingHydrantsAdd()
        }
        if (this.computedLiftmaintenanceCablesMapVisibility) {
          this.mapLayerLiftmaintenanceCablesAdd()
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/mapComponent.vue